import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import pluralize from 'pluralize';
import { read_artifacts } from "../../services/api";
import { errorMsg } from "../../helper/helpers";
import excel from "../../assets/excel.png";
import report from "../../assets/report.png";
import email from "../../assets/email.png";
import phone from "../../assets/phone.png";
import txt_msg from "../../assets/txt_msg.png";
import reviews from "../../assets/reviews.png";
import contract from "../../assets/contract.png";
import contract_new from "../../assets/contract_new.png";
import help from "../../assets/help.png";
import Button from "./Button";
import EmailInbox from "./EmailInbox";
import Contract from "./Contract";
import ExcelFile from "./ExcelFile";
import PhoneCalls from "./PhoneCalls";
import Reports from "./Reports";
import TextMessages from "./TextMessages";
import Reviews from "./Reviews";
const Header = ({ headerState }) => {
  const [
    isOverlay,
    setIsOverlay,
    simPopup,
    setSimPopup,
    headerPopup,
    setHeaderPopup,
    isArtifacts,
    ulPopup,
    setUlPopup,
    plPopup,
    setPlPopup,
    skipWalkThruPopups,
    simObj,
    setSimObj,
    getMonth,
    toggleSimulation,
    setToggleSimulation,
    isPopupOverlay,
    setIsPopupOverlay,
    setError,
    simType,
    isWaitForMoreBids,
    setIsWaitForMoreBids,
    qmPopup,
    setQmPopup,
    kpisPopup,
    setKpisPopup,
    fcPopup,
    setFcPopup,
    relaunchPopup,
    setRelaunchPopup,
    scmPopup,
    setScmPopup,
    viewBidsPopup, 
    setViewBidsPopup,
    pmPopup,
    setPmPopup
  ] = headerState;
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [showContractPopup, setShowContractPopup] = useState(false);
  const [showExcelPopup, setShowExcelPopup] = useState(false);
  const [showPhoneCallPopup, setshowPhoneCallPopup] = useState(false);
  const [showReportPopup, setShowReportPopup] = useState(false);
  const [showTextMsgPopup, setshowTextMsgPopup] = useState(false);
  const [showReviewsPopup, setShowReviewsPopup] = useState(false);
  const [isListPopupShown, setIsListPopupShown] = useState(false);
  const [popupLeft, setPopupLeft] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  let title =
    simType == "im"
      ? "Inventory Management"
      : simType == "fc"
        ? "Forecasting"
        : simType == "pm"
          ? "Project Management"
          : simType == "qm"
            ? "Quality Management"
            : simType == "scm"
              ? "Supply Chain Management"
              : "";
  // const [activeTab, setActiveTab] = useState("");

  // const updatePopupLeft = (e)=> {
  //   let newLeft = e.target.offsetParent.offsetParent.offsetParent.offsetLeft;
  //   setPopupLeft(newLeft);
  // }
  const addSpaceAfterDot = (inputString)=> {
    // Use a regular expression to match a dot followed by a letter
    var regex = /\.(?=[a-zA-Z])/;
  
    // Check if the string contains a dot followed by a letter and doesn't end with a space
    if (regex.test(inputString) && !inputString.endsWith(' ')) {
      // Add a space after the dot
      return inputString.replace(regex, '. ');
    }
    return inputString; // Return the original string if no change is needed
  }
  const emailPopupHandler = (e) => {
    setToggleSimulation(false);
    closePopups();
    setShowEmailPopup(!showEmailPopup);
    setIsListPopupShown(true);
    setIsPopupOverlay(!showEmailPopup);
  };
  const contractPopupHandler = (e) => {
    setToggleSimulation(false);
    closePopups();
    setShowContractPopup(!showContractPopup);
    setIsListPopupShown(true);
    setIsPopupOverlay(!showContractPopup);
  };

  const excelPopupHandler = () => {
    setToggleSimulation(false);
    closePopups();
    setShowExcelPopup(!showExcelPopup);
    setIsListPopupShown(true);
    setIsPopupOverlay(!showExcelPopup);
  };
  const phoneCallPopupHandler = () => {
    setToggleSimulation(false);
    closePopups();
    setshowPhoneCallPopup(!showPhoneCallPopup);
    setIsListPopupShown(true);
    setIsPopupOverlay(!showPhoneCallPopup);
  };
  const reportPopupHandler = (e) => {
    setToggleSimulation(false);
    closePopups();
    setShowReportPopup(!showReportPopup);
    setIsListPopupShown(true);
    setIsPopupOverlay(!showReportPopup);
  };
  const txtMsgPopupHandler = () => {
    setToggleSimulation(false);
    closePopups();
    setshowTextMsgPopup(!showTextMsgPopup);
    setIsListPopupShown(true);
    setIsPopupOverlay(!showTextMsgPopup);
  };
  const reviewsPopupHandler = () => {
    setToggleSimulation(false);
    closePopups();
    setShowReviewsPopup(!showReviewsPopup);
    setIsListPopupShown(true);
    setIsPopupOverlay(!showReviewsPopup);
  };
  const loadNextPopUp = () => {
    setHeaderPopup(false);
    if (simType === "im") {
      setKpisPopup(true);
    } else if (simType === "qm") {
      window.$("#decisionMain>div:first button:first").click();
      setQmPopup((prevQmPopup) => ({
        ...prevQmPopup,
        availableCash: true,
      }));
    } else if (simType === "fc") {
      setFcPopup((prevFcPopup) => ({
        ...prevFcPopup,
        actualDemand: true,
      }));
    } else if (simType === "scm") {
      window.$("#decisionMain>div:first button:first").click();
      setScmPopup((prevScmPopup) => ({
        ...prevScmPopup,
        bidsOrder: true,
      }));
    } else {
      // setSimPopup(true);
      setPmPopup((prevPmPopup) => ({
        ...prevPmPopup,
        aonDiagram: true,
      }));
      let target = document.querySelector("#AonGraph");
      target.scrollTo(0,0);
    }
  };
  const closePopups = () => {
    if (isListPopupShown) {
      if (showReportPopup) {
        document.querySelector(".reports-link").focus();
      } else if (showEmailPopup) {
        document.querySelector(".email-link").focus();
      } else if (showContractPopup) {
        document.querySelector(".contract-link").focus();
      } else if (showPhoneCallPopup) {
        document.querySelector(".phone-link").focus();
      } else if (showTextMsgPopup) {
        document.querySelector(".textmsg-link").focus();
      } else if (showReviewsPopup) {
        document.querySelector(".review-link").focus();
      }
      setShowEmailPopup(false);
      setShowContractPopup(false);
      setShowExcelPopup(false);
      setshowPhoneCallPopup(false);
      setShowReportPopup(false);
      setshowTextMsgPopup(false);
      setShowReviewsPopup(false);
      setIsListPopupShown(false);
      setIsPopupOverlay(false);
      if (showReviewsPopup || showEmailPopup || showTextMsgPopup) {
        if (document.querySelector("#details") != null) {
          document.querySelector("#details").setAttribute("tabindex", "0");
        }
        if (document.querySelector("#progressed-goal") != null) {
          document
            .querySelector("#progressed-goal")
            .setAttribute("tabindex", "0");
        }
      }
    }
  };
  const showHelp = () => {
    setIsListPopupShown(false);
    closePopups();
    setIsOverlay(true);
    setHeaderPopup(true);
    setToggleSimulation(false);
    document.querySelector(".main").setAttribute("aria-hidden", "false");
  };
  const updateReadStatus = (e) => {
    if (e.key == "Enter" || e.type == "click") {
      let newArtifacts = [];
      if (window.$(e.target).closest(".review-box").length == 0) {
        document.querySelector(
          ".popup-box .section .ui.grid"
        ).lastElementChild.scrollTop = 0;
      }
      let artifacts = simObj.artifacts;
      let readArtifactIds =
        simObj.readArtifactIds == ""
          ? simObj.readArtifactIds.split("")
          : simObj.readArtifactIds.split(",");
      artifacts = artifacts.map((data) => {
        data.ci = "";
        if (data.aii == e.currentTarget.id) {
          if (data.md == "TEXTS") {
            artifacts
              .filter(
                (artifactObj) =>
                  artifactObj.md == "TEXTS" &&
                  artifactObj.val.sender == data.val.sender
              )
              .map((data) => {
                if (data.rs != 1) {
                  data.rs = 1;
                  data.ci = e.currentTarget.id;
                  if (!readArtifactIds.includes(data.aii)) {
                    let artifactObj = {
                      id: simObj?.id,
                      executioninstanceid: simObj?.executioninstanceid,
                      currentstep: simObj?.currentstep,
                      readArtifactIds: data?.aii,
                    };
                    simObj.status != "COMPLETED" &&
                      read_artifacts(simObj?.sessionid, artifactObj, simType)
                        .then(function (response) {
                          if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                            setError(response?.data)
                          }
                          else{
                            newArtifacts = response.data.artifacts;
                          }
                        })
                        .catch((error) => {
                          // setError(errorMsg);
                          setError({"id":"00000","msg":errorMsg})
                          console.log(error);
                        });
                  }
                } else {
                  newArtifacts = artifacts;
                }
              });
          } else {
            // console.log("currentTarget:" + e.currentTarget.id, "artifactid_id:" + data.aii);
            if (data.rs != 1) {
              data.rs = 1;
              if (
                data.md != "REVIEWS" ||
                e.currentTarget.getAttribute("artifact_id") ==
                e.currentTarget.id
              ) {
                data.ci = e.currentTarget.id;
              }
              if (!readArtifactIds.includes(data.aii)) {
                let artifactObj = {
                  id: simObj?.id,
                  executioninstanceid: simObj?.executioninstanceid,
                  currentstep: simObj?.currentstep,
                  readArtifactIds: data?.aii,
                };
                simObj.status != "COMPLETED" &&
                  read_artifacts(simObj?.sessionid, artifactObj, simType)
                    .then(function (response) {
                      //console.dir("New Artifacts:" + JSON.stringify(response.data.artifacts));
                      if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                        setError(response?.data)
                      }
                    else{
                      newArtifacts = response.data.artifacts;
                    }
                      // console.log("response:" + JSON.stringify(response.data.artifacts));
                    })
                    .catch((error) => {
                      // setError(errorMsg);
                      setError({"id":"00000","msg":errorMsg})
                      console.log(error);
                    });
              }
            } else {
              newArtifacts = artifacts;
            }
          }
        } else if (
          data.md == "REVIEWS" &&
          data.aii == e.currentTarget.getAttribute("artifact_id")
        ) {
          data.ci = e.currentTarget.getAttribute("artifact_id");
        }
      });

      // console.log("before merge artifacts:" + JSON.stringify(newArtifacts));

      setSimObj((prevObj) => ({
        ...prevObj,
        [artifacts]: newArtifacts,
        readArtifactIds:
          simObj.status != "COMPLETED" ? readArtifactIds.join(",") : "",
      }));
    }
  };
  const handleResize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };
  const changeTabs = (e) => {
    if (
      document.querySelector(".popup-container ui.stackable.two.column.grid") ==
      null
    ) {
      const target = window.$(e.target).closest(".item.tab-item")[0];
      const parent = target.parentNode;
      const grandparent = parent.parentNode;

      // Remove all current selected tabs
      parent
        .querySelectorAll('[aria-selected="true"]')
        .forEach((t) => {
          t.setAttribute("aria-selected", false);
          t.classList.remove("active");
        });

      // Set this tab as selected
      target.setAttribute("aria-selected", true);
      target.classList.add("active");

      // Hide all tab panels
      Array.from(window.$(grandparent).closest(".ui.two.column.grid").find(".ten.wide [role='tabpanel']"))
        .forEach((p) => {
          p.setAttribute("hidden", true);
          p.classList.remove("active");
        });

      // Show the selected panel
      let targetId = target.getAttribute("aria-controls");
      document.getElementById(targetId).removeAttribute("hidden");
      document.getElementById(targetId).classList.add("active");
      // if (document.getElementById(targetId).querySelectorAll(".review-item").length > 0) {
      //   document.getElementById(targetId).querySelectorAll(".review-item").forEach((item) => {
      //     item.tabIndex = 0;
      //   })
      // }
      setTimeout(() => {
        if (document.getElementById(targetId) != null) {
          if (
            document.getElementById(targetId).querySelectorAll(".review-item")
              .length > 0
          ) {
            if (
              document
                .getElementById(targetId)
                .querySelector(".review-item .ui.compact.message")
            ) {
              document
                .getElementById(targetId)
                .querySelector(".review-item .ui.compact.message")
                .focus();
            }
          } else {
            document.getElementById(targetId).tabIndex = 0;
            document.getElementById(targetId).focus();
          }
        }
      }, 1000);
    }
  };

  const handleTabs = () => {
    const tabs = document.querySelectorAll('header [role="tab"]');
    const tabList = document.querySelector('header [role="tablist"]');

    // Add a click event handler to each tab
    tabs.forEach((tab) => {
      tab.addEventListener("click", (e) => {
        changeTabs(e);
        const tabs = document.querySelectorAll('header [role="tab"]');
        let activeTab = window.$(e.target).closest(".item.tab-item")[0];
        tabs.forEach((tab) => {
          tab.setAttribute("tabindex", "-1");
        });
        setTimeout(() => {
          activeTab.setAttribute("tabindex", "0");
          tabFocus = Array.from(tabs).indexOf(activeTab);
        }, 0);
      });
    });

    // Enable arrow navigation between tabs in the tab list
    let tabFocus = 0;
    if (tabList != null) {
      tabList.addEventListener("keydown", (event) => {
        // Move right
        const tabs = document.querySelectorAll('header [role="tab"]');
        if ((event.shiftKey && event.key === "Tab") || event.key == "Tab") {
          let activeTab = document.querySelector(`header [role="tab"].active`);
          tabs.forEach((tab) => {
            tab.setAttribute("tabindex", "-1");
          });
          setTimeout(() => {
            activeTab.setAttribute("tabindex", "0");
            tabFocus = Array.from(tabs).indexOf(activeTab);
          }, 100);
        }
        if (
          event.key === "ArrowRight" ||
          event.key === "ArrowLeft" ||
          event.key === "ArrowUp" ||
          event.key === "ArrowDown" ||
          event.key === "Home" ||
          event.key === "End"
        ) {
          event.target.setAttribute("tabindex", -1);
          tabs[tabFocus].setAttribute("tabindex", -1);
          if (event.key === "ArrowRight" || event.key === "ArrowDown") {
            tabFocus++;
            // If we're at the end, go to the start
            if (tabFocus >= tabs.length) {
              tabFocus = 0;
            }
            // Move left
          } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
            tabFocus--;
            // If we're at the start, move to the end
            if (tabFocus < 0) {
              tabFocus = tabs.length - 1;
            }
          } else if (event.key === "Home") {
            tabFocus = 0;
          } else if (event.key === "End") {
            tabFocus = tabs.length - 1;
          }
          event.preventDefault();
          tabs[tabFocus].setAttribute("tabindex", 0);
          tabs[tabFocus].focus();
        }
      });
    }

    // tabs[0].click();
  };
  const calculatePopupLeft = () => {
    if (window.$(".report-box").length > 0) {
      let newLeft =
        window.$(".reports-link").offset().left -
        window.$(".report-box").offset().left +
        10;
      setPopupLeft(newLeft);
    } else if (window.$(".email-box").length > 0) {
      let newLeft =
        window.$(".email-link").offset().left -
        window.$(".email-box").offset().left +
        10;
      setPopupLeft(newLeft);
    } else if (window.$(".contract-box").length > 0) {
      let newLeft =
        window.$(".contract-link").offset().left -
        window.$(".contract-box").offset().left +
        10;
      setPopupLeft(newLeft);
    } else if (window.$(".phone-box").length > 0) {
      let newLeft =
        window.$(".phone-link").offset().left -
        window.$(".phone-box").offset().left +
        10;
      setPopupLeft(newLeft);
    } else if (window.$(".text-msg-box").length > 0) {
      let newLeft =
        window.$(".textmsg-link").offset().left -
        window.$(".text-msg-box").offset().left +
        10;
      setPopupLeft(newLeft);
    } else if (window.$(".review-box").length > 0) {
      let newLeft =
        window.$(".review-link").offset().left -
        window.$(".review-box").offset().left +
        10;
      setPopupLeft(newLeft);
    }
  };
  window.$(document).on('focus',".email-link, .phone-link, .textmsg-link, .contract-link, .review-link, .reports-link, .help-link", function() {
      window.$(this).popup('show');
  });
  window.$(document).on('blur',".email-link, .phone-link, .textmsg-link, .contract-link, .review-link, .reports-link, .help-link", function() {
    window.$(this).popup('hide'); // Hide popup when element loses focus
});
  useEffect(() => {
    document.querySelector("header.header h1").tabIndex = -1;
    // console.log("after merge artifacts:" + JSON.stringify(simObj.artifacts));
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    calculatePopupLeft();
    var mainDiv = document.querySelector(".main");
    var focusableElementsMain = mainDiv.querySelectorAll(
      "a[href], button, input, select, textarea"
    );

    var footerDiv = document.querySelector("footer.footer");
    var focusableElementsFooter = footerDiv.querySelectorAll(
      "a[href], button, input, select, textarea"
    );

    var focusableElementsHeader = document.querySelectorAll(
      ".skip-to-main-content-link"
    );

    var tabFocusable = document.querySelectorAll(
      '[tabindex]:not([tabindex="-1"]'
    );
    var tabNotFocusable = document.querySelectorAll('[tabindex="-1"]');

    var allFocusableElements = [
      ...focusableElementsMain,
      ...focusableElementsFooter,
      ...focusableElementsHeader,
    ];
    if (
      window.$(".report-box").length > 0 ||
      window.$(".email-box").length > 0 ||
      window.$(".contract-box").length > 0 ||
      window.$(".phone-box").length > 0 ||
      window.$(".text-msg-box").length > 0 ||
      window.$(".review-box").length > 0
    ) {
      allFocusableElements.forEach(function (element) {
        element.setAttribute("tabindex", "-1");
      });
      tabFocusable.forEach(function (element) {
        if (window.$(element).closest(".ui.pointing").length == 0) {
          element.setAttribute("tabindex", "-1");
        }
      });
      document
        .querySelector(".skip-to-main-content-link")
        .setAttribute("aria-hidden", "true");
    } else {
      allFocusableElements.forEach(function (element) {
        element.removeAttribute("tabindex");
      });
      tabFocusable.forEach(function (element) {
        element.setAttribute("tabindex", "0");
      });
      // tabNotFocusable.forEach(function (element) {
      //   if(window.$(element).closest(".ui.pointing").length == 0){
      //     element.setAttribute('tabindex', '-1');
      //   }
      // });
      if(window.$("#monthSelector").closest(".ui.dropdown")){
        window.$("#monthSelector").closest(".ui.dropdown").attr("tabindex", 0)
      }
      document
        .querySelector(".skip-to-main-content-link")
        .setAttribute("aria-hidden", "false");
      if (document.querySelectorAll(".Graphs button") != null) {
        const elementsWithClassGraphs =
          document.querySelectorAll(".Graphs button");
        elementsWithClassGraphs.forEach((element) => {
          if (element.getAttribute("aria-selected") === "false") {
            element.setAttribute("tabindex", "-1");
          }
        });
      }
      if (
        document.querySelectorAll("#panel_2 .ten.wide table tr td button") !=
        null
      ) {
        document
          .querySelectorAll("#panel_2 .ten.wide table tr td button")
          .forEach((element) => {
            element.setAttribute("tabindex", "-1");
          });
      }
      if (document.querySelectorAll("#decisionMain button") != null) {
        document.querySelectorAll("#decisionMain button").forEach((element) => {
          if (element.getAttribute("aria-selected") === "false") {
            element.setAttribute("tabindex", "-1");
          }
        });
      }

      if (
        document.querySelector(
          "#RevenueGraph-Quality .highcharts-container "
        ) != null ||
        document.querySelector("#Failure-rate-Graph .highcharts-container ") !=
        null
      ) {
        document
          .querySelector("#RevenueGraph-Quality .highcharts-container ")
          .setAttribute("tabindex", "0");
        document
          .querySelector("#Failure-rate-Graph .highcharts-container ")
          .setAttribute("tabindex", "0");
      }
      if (
        document.querySelector("#RevenueGraph .highcharts-container ") !=
        null ||
        document.querySelector("#InventoryGraph .highcharts-container ") != null
      ) {
        document
          .querySelector("#RevenueGraph .highcharts-container ")
          .setAttribute("tabindex", "0");
        document
          .querySelector("#InventoryGraph .highcharts-container ")
          .setAttribute("tabindex", "0");
      }
      if(document.querySelector("#ActualDemandGraph .highcharts-container ")){
        document
          .querySelector("#ActualDemandGraph .highcharts-container ")
          .setAttribute("tabindex", "0");
      }
      if(document.querySelector("#APE-Range .highcharts-container ")){
        document
          .querySelector("#APE-Range .highcharts-container ")
          .setAttribute("tabindex", "0");
      }
      if(document.querySelector("#Demand-Graph .highcharts-container ")){
        document
          .querySelector("#Demand-Graph .highcharts-container ")
          .setAttribute("tabindex", "0");
      }
      if (document.querySelector("#TrackingSignal .highcharts-container ")) {
        document
          .querySelector("#TrackingSignal .highcharts-container ")
          .setAttribute("tabindex", "0");
      }
      if(document.querySelectorAll(".header .artifacts-list li a")){
      document.querySelectorAll(".header .artifacts-list li a").forEach(function (element) {
        element.removeAttribute('tabindex');
      });
    }
    }
    if (
      window.$(".report-box").length > 0 ||
      window.$(".email-box").length > 0 ||
      window.$(".contract-box").length > 0 ||
      window.$(".phone-box").length > 0 ||
      window.$(".text-msg-box").length > 0 ||
      window.$(".review-box").length > 0
    ) {
      handleTabs();
    }
  }, [
    showReportPopup,
    showEmailPopup,
    showContractPopup,
    showPhoneCallPopup,
    showTextMsgPopup,
    showReviewsPopup,
  ]);
  useEffect(() => {
    if (
      window.$(".report-box").length > 0 ||
      window.$(".email-box").length > 0 ||
      window.$(".contract-box").length > 0 ||
      window.$(".phone-box").length > 0 ||
      window.$(".text-msg-box").length > 0 ||
      window.$(".review-box").length > 0
    ) {
      handleTabs();
    }
  }, [simObj?.artifacts]);
  useEffect(() => {
    calculatePopupLeft();
  }, [windowSize]);

  let ReportsDataCount = simObj.artifacts?.filter(
    (data) => data.rs == 0 && data.md == "REPORTS"
  ).length;
  let EmailsDataCount = simObj.artifacts?.filter(
    (data) => data.rs == 0 && data.md == "EMAILS"
  ).length;
  let ContractDataCount = simObj.artifacts?.filter(
    (data) => data.rs == 0 && data.md == "CONTRACT"
  ).length;
  let PhonesDataCount = simObj.artifacts?.filter(
    (data) => data.rs == 0 && data.md == "PHONES"
  ).length;
  let TextsDataCount = simObj.artifacts?.filter(
    (data) => data.rs == 0 && data.md == "TEXTS"
  ).length;
  let ReviewsDataCount = simObj.artifacts?.filter(
    (data) => data.rs == 0 && data.md == "REVIEWS"
  ).length;

  let variables = {
    yearlyProfitTarget: simObj?.laststate?.yearlyProfitTarget,
    "Cibare" : (simObj?.userData && simObj?.userData!="") ? simObj?.userData : "Cibare",
    "DigiLife" : (simObj?.userData && simObj?.userData!="") ? simObj?.userData : "DigiLife",
  };
  const formatNum = (num) => {
    return num?.toLocaleString('en-US', { style: 'decimal' });
  }
  const replaceVariables = (html) => {
    if(simType == "qm"){
      return html.replaceAll("Cibare",(simObj?.userData && simObj?.userData!="") ? simObj?.userData : "Cibare").replaceAll("STUDENSTORENAME",(simObj?.userData && simObj?.userData!="") ? simObj?.userData : "Cibare").replaceAll("STUDENTSTORENAME",(simObj?.userData && simObj?.userData!="") ? simObj?.userData : "Cibare").replace(
        /\$\$\$(\w+)/g,
        (match, variable) => "$" + variables[variable] || match
      );
    }
    else if (simType == "im") {
      return html.replaceAll("DigiLife",(simObj?.userData && simObj?.userData!="") ? simObj?.userData : "DigiLife").replaceAll("yearlyProfitTarget",simObj?.laststate?.yearlyProfitTarget? formatNum(simObj?.laststate?.yearlyProfitTarget):0)
    }
    else if (simType == "fc") {
      return html.replaceAll("$mapeToGoal",simObj?.mapeToGoal ? simObj?.mapeToGoal : 0).replace(
        /\$\$\$(\w+)/g,
        (match, variable) => "$" + variables[variable] || match
      );
    }
    else if (simType == "scm") {
      return html.replaceAll("gizmo ",(simObj?.userData && simObj?.userData!="") ? simObj?.userData+" " : "gizmo ").replaceAll("gizmo.",(simObj?.userData && simObj?.userData!="") ? simObj?.userData+"." : "gizmo.").replaceAll("gizmos",(simObj?.userData && simObj?.userData!="") ? pluralize(simObj?.userData,2) : "gizmos").replace(
        /\$\$\$(\w+)/g,
        (match, variable) => "$" + variables[variable] || match
      );
    }
    else{
      return html.replace(
        /\$\$\$(\w+)/g,
        (match, variable) => "$" + variables[variable] || match
      );
    }
  };
  useEffect(()=>{
    if(isArtifacts && window.innerWidth>991){
      window.$('.artifact-listitem a').popup();
    }
  },[isArtifacts])

  return (
    <header className="header main-header">
      <div className="container">
        <h1 className="title" aria-hidden={isPopupOverlay}>
          {title}
        </h1>
        {isArtifacts ? (
          <div className="artifacts">
            <nav className="artifacts-nav field">
              <ul className={`artifacts-list ${headerPopup || isListPopupShown ? `show` : "" } ${isListPopupShown ? "headerPopup" : ""}`} style={ isListPopupShown ? { zIndex: 2, position: "relative" } : {} }>
                {(simType == "im") && (
                  <li className="artifact-listitem" style={headerPopup ? { paddingLeft: 0 } : {}} >
                    <a href="#" className="reports-link" data-content="REPORTS AND MEMOS" onClick={reportPopupHandler} data-count={ReportsDataCount} role="button" aria-label="Reports and Memos">
                      <img className="image reports" src={report} alt="" />
                    </a>
                  </li>
                )}
                {simType == "qm" && (
                  <li className="artifact-listitem">
                    <a href="#" className="review-link" data-content="REVIEWS" onClick={reviewsPopupHandler} data-count={ReviewsDataCount} role="button" aria-label="Reviews">
                      <img className="image" src={reviews} alt="" />
                    </a>
                  </li>
                )}

                <li className="artifact-listitem">
                  <a href="#" className={`email-link ${viewBidsPopup ? `show` : ""  }`} data-content="EMAIL INBOX" onClick={emailPopupHandler} data-count={EmailsDataCount} role="button" aria-label="Email Inbox">
                    <img className="image email" src={email} alt="" />
                  </a>
                </li>
                {
                  viewBidsPopup ? <div className={`ui pointing label view-bid-popup`} role='dialog' aria-modal="true" aria-label="View Bids popup" tabIndex={-1}>
                    <p>Bids will come in via the Email Inbox. You will get a per unit price for the SKU at different order volumes. If you want to order right away you can click View Bids at the end of the message or wait for more bids to come in.</p>
                    <div className={`mt10 dflex`}>
                      <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                      <Button btnName="Next" btnId="btnNext" btnParentClassName={`ml10`} btnWidth="80" clickEventHandler={()=>{
                        window.$("#decisionMain>div:first button:last").click();
                        // window.$(".order-tabs button:first").click();
                        setScmPopup((prevScmPopup) => ({...prevScmPopup, ['placeOrders'] : true}));
                        setViewBidsPopup(false);
                      }} />
                    </div>
                  </div> : ''
                }

                
                {(simType == "im" || simType == "fc" || simType == "pm") && (
                  <li className="artifact-listitem">
                    <a  href="#" className="phone-link" data-content="PHONE CALLS" onClick={phoneCallPopupHandler} data-count={PhonesDataCount} role="button" aria-label="Phone Calls">
                      <img className="image phone" src={phone} alt="" />
                    </a>
                  </li>
                )}
                <li className="artifact-listitem">
                  <a href="#" className="textmsg-link" data-content="TEXT MESSAGES" onClick={txtMsgPopupHandler} data-count={TextsDataCount} role="button" aria-label="Text Messages">
                    <img  className="image textmsg" src={txt_msg} alt="" />
                  </a>
                </li>
                {(simType == "scm") && (
                  <li className="artifact-listitem">
                    <a href="#" className="contract-link" data-content="CONTRACT" onClick={contractPopupHandler} data-count={ContractDataCount} role="button" aria-label="Contract Inbox">
                      <img className="image contract" src={contract_new} alt="" />
                    </a>
                </li>
                )}
                <li className="artifact-listitem">
                  <a href="#" className={`help-link ${relaunchPopup ? `show` : ""  }`} data-content="HELP" onClick={showHelp} role="button" aria-label="Help">
                    <img className="image help" src={help} alt="" />
                  </a>
                </li>
              </ul>
              {relaunchPopup ? (
                <div
                  className={`ui pointing label relaunch-popup`}
                  role="dialog"
                  tabIndex={-1}
                  aria-modal="true"
                  aria-label="Finish information popup"
                >
                  <p>
                    If you ever want to re-launch this Walk-through, click the <img className="image help" src={help} alt="Help" /> icon.
                  </p>
                  <div className={`mt10 dflex`}>
                    <Button
                      btnName="Finish"
                      btnId="btnNext"
                      btnParentClassName={`ml10`}
                      btnWidth="80"
                      clickEventHandler={() => {
                        setRelaunchPopup(false);
                        setIsOverlay(false);
                      }}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}

              {headerPopup ? (
                <div className={`ui pointing label`} role="dialog" tabIndex={-1} aria-modal="true" aria-label="Help popup">
                  {simType == "im" ? (
                    <p>
                      Carefully review your documents and communications for
                      information to help you make your first order.
                    </p>
                  ) : simType == "qm" ? (
                    <p>
                      Carefully review your reviews and communications for
                      information to help you make your first quality investment
                      decision.
                    </p>
                  ) : simType == "fc" ? (
                    <p>
                      Carefully review your documents and communications for 
                      information to help you make your first forecast, 
                      keeping an eye out for historical demand.
                     </p>
                  ) : simType == "scm" ? (
                    <p>
                      Carefully review your documents, communications, and contracts 
                      for information to help you make your first decision on which bids to request. 
                      Hint: Keep a special eye out for the Guidelines.
                    </p>
                  ) :
                  (
                    <p>
                      Carefully review your communications for
                      information to help you make the best decisions about contractors.
                    </p>
                  )}
                  <div className={`mt10 dflex`}>
                    <Button
                      btnName="Skip Walk-Thru"
                      btnWidth="130"
                      clickEventHandler={skipWalkThruPopups}
                    />
                    <Button
                      btnName="Next"
                      btnParentClassName={`ml10`}
                      btnId="btnNext1"
                      btnWidth="80"
                      clickEventHandler={loadNextPopUp}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}

              {showExcelPopup ? <ExcelFile /> : ""}
              {showReportPopup ? (
                <Reports
                  simObj={simObj}
                  setSimObj={setSimObj}
                  updateReadStatus={updateReadStatus}
                  closePopups={closePopups}
                  getMonth={getMonth}
                  replaceVariables={replaceVariables}
                  popupLeft={popupLeft}
                  addSpaceAfterDot = {addSpaceAfterDot}
                />
              ) : (
                ""
              )}
              {showReviewsPopup ? (
                <Reviews
                  simObj={simObj}
                  setSimObj={setSimObj}
                  updateReadStatus={updateReadStatus}
                  closePopups={closePopups}
                  getMonth={getMonth}
                  replaceVariables={replaceVariables}
                  popupLeft={popupLeft}
                  addSpaceAfterDot = {addSpaceAfterDot}
                />
              ) : (
                ""
              )}
              {showEmailPopup ? (
                <EmailInbox
                  simObj={simObj}
                  setSimObj={setSimObj}
                  updateReadStatus={updateReadStatus}
                  closePopups={closePopups}
                  getMonth={getMonth}
                  replaceVariables={replaceVariables}
                  popupLeft={popupLeft}
                  setToggleSimulation = {setToggleSimulation}
                  isWaitForMoreBids = {isWaitForMoreBids}
                  setIsWaitForMoreBids = {setIsWaitForMoreBids}
                  addSpaceAfterDot = {addSpaceAfterDot}
                />
              ) : (
                ""
              )}
              {
                showContractPopup ? (
                  <Contract
                    simObj={simObj}
                    setSimObj={setSimObj}
                    updateReadStatus={updateReadStatus}
                    closePopups={closePopups}
                    getMonth={getMonth}
                    replaceVariables={replaceVariables}
                    popupLeft={popupLeft}
                    addSpaceAfterDot = {addSpaceAfterDot}
                  />
                ) : (
                  ""
                )
              }
              {showPhoneCallPopup ? (
                <PhoneCalls
                  simObj={simObj}
                  setSimObj={setSimObj}
                  updateReadStatus={updateReadStatus}
                  closePopups={closePopups}
                  getMonth={getMonth}
                  replaceVariables={replaceVariables}
                  popupLeft={popupLeft}
                  addSpaceAfterDot = {addSpaceAfterDot}
                />
              ) : (
                ""
              )}
              {showTextMsgPopup ? (
                <TextMessages
                  simObj={simObj}
                  setSimObj={setSimObj}
                  updateReadStatus={updateReadStatus}
                  closePopups={closePopups}
                  getMonth={getMonth}
                  replaceVariables={replaceVariables}
                  popupLeft={popupLeft}
                  addSpaceAfterDot = {addSpaceAfterDot}
                />
              ) : (
                ""
              )}
            </nav>
          </div>
        ) : (
          ""
        )}
      </div>
    </header>
  );
};

export default Header;
